import { render, staticRenderFns } from "./ResolDeltaSolMx_2d11.vue?vue&type=template&id=5609631c&"
import script from "./ResolDeltaSolMx_2d11.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolMx_2d11.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports